/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { FeaturePanelsSectionFragment } from "@cosmos/hygraph-schema";

import { ResponsiveContainer, SectionHeading, BackgroundContainer, SectionContainer } from "@components/elements";
import { extractBackgroundContainerProps, extractSectionContainerProps } from "@components/utils/section.utils";

import { FeaturePanels } from "./FeaturePanels.organism";
import { VStack } from "@panda/jsx";

export const FeaturePanelsSection = ({
	config,
	cards,
	disableCardBg,
	verticallyCenter,
	buttons,
}: FeaturePanelsSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(cards?.length || buttons?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)}>
			<ResponsiveContainer>
				<SectionContainer {...extractSectionContainerProps(config)}>
					<VStack alignItems="stretch" gap="eds.dimension.48" className="feature-panels-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? (
							<FeaturePanels
								cards={cards || []}
								disableCardBg={disableCardBg}
								verticallyCenter={verticallyCenter}
								buttons={buttons}
							/>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
